<template>
  <v-container
    id="homeView"
    tag="section"
  >
    <v-row>
      <welcome-widget />
    </v-row>
    
    <v-row>
      <module-browser />
    </v-row>
  </v-container>
</template>

<script>
  import 'firebase/auth'
  // import shortcodeGenerator from './ShortcodeGenerator.vue'
  // import CertificateDisplay from './CertificateDisplay.vue'
  import ModuleBrowser from './ModuleBrowser.vue'
  import WelcomeWidget from './Welcome.vue'

  export default {
    name: 'Home',

    components: {
      // 'shortcode-generator': shortcodeGenerator,
      // 'activity-view': activityView,
      // 'certificate-display': CertificateDisplay,
      'module-browser': ModuleBrowser,
      'welcome-widget': WelcomeWidget,
    },

    data: () => ({
      loading: true,
    }),

    computed: {
      activityTitle () {
        return this.classLearner ? this.$t('learner.activity-title', [this.classLearner.user.displayName]) : this.$t('global.loading')
      },
      userID () {
        return this.$query.learner ?? this.$store.getters.currentUserProfile.user.id
      },
      classLearnerID () {
        return this.classLearner ? this.classLearner.id : undefined
      },
      userFirstName () {
        return this.$store.state.user ? this.$store.getters.currentUserProfile.user.displayName.split(' ')[0] : ''
      },
      userIsLearner () {
        return this.$store.state.user ? this.$store.getters.currentUserProfile.user.roles.includes('learner') : false
      },
      breadcrumbs () {
        return [
          {
            text: this.$t('nav.learner'),
            disabled: false,
            href: '#/admin/learner/',
          },
        ]
      },
    },
  }
</script>

<style>
</style>
